<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="font-weight-regular">
        <slot></slot>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-icon>
      <v-icon v-if="fulfilled" color="green">{{icons.mdiCheckCircle}}</v-icon>
      <v-icon v-else color="red">{{icons.mdiMinusCircle}}</v-icon>
    </v-list-item-icon>
  </v-list-item>
</template>

<script>
  import {mdiCheck, mdiMinusCircle, mdiCheckCircle} from '@mdi/js';

  export default {
    name: 'RequirementLine',
    props: ['subtitle', 'fulfilled'],
    data() {
      return {
        icons: {mdiCheck, mdiMinusCircle, mdiCheckCircle}
      }
    }
  }
</script>

<style scoped lang="scss">
  .v-list--dense .v-list-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
</style>
